import type { TPlan } from "@/core/environment/types";
import { analyticsApi, track } from "@/features/analytics";
import type { TOrgInfo } from "@/types";
import moment from "moment";

const handleAnalytics = ({
  plan,
  account,
}: {
  plan: TPlan;
  account: TOrgInfo;
}) => {
  const data: Record<string, unknown> = {};
  if (plan) {
    data.plan = plan.title;
    data.billingPeriod = plan.period;
    data.monthlyValue =
      plan.period === "Monthly" ? plan.price : plan.price / 12;

    analyticsApi.postHubspotProperty({
      total_payment_amount: plan.price,
      number_of_seats: plan.seats,
      plan_billing_type: plan.period,
      plan_monthly_value:
        plan.period === "Monthly" ? plan.price : plan.price / 12,
      plan_name: plan.title,
      trial_status: "inactive",
      success_paying_customer: moment(new Date())
        .utc()
        .startOf("day")
        .valueOf(),
    });
  }
  track("success upgrade customer", {
    isAfterSuccessPaying: true,
    "upgrade subscription plan": true,
    "upgrade subscription plan type": "starter to pro",
    "subscription title": plan.title,
    "subscription period": plan.period,
    "subscription price": plan.price,
  });
  if (account.parameters?.gclid) data["gclid"] = account.parameters.gclid;
  analyticsApi.postHubspotEvent("success upgrade customer", data);
};

export default handleAnalytics;
